<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM KỲ THI</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-text-field
            label="Tên kỳ kiểm tra"
            v-model="name"
            outlined
            required
            :rules="[$rules.required]"
            class="required"
          ></v-text-field>
          <SelectAcademicLevel @change="acaChange" />
          <v-select
            label="Loại kiểm tra"
            :items="typeOptions"
            item-text="label"
            item-value="value"
            v-model="type"
            outlined
            :rules="[$rules.required]"
            class="required"
          ></v-select>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            class="required pt-6"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date" label="Ngày" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title scrollable @input="menu = false" />
          </v-menu>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="reviewDate"
                label="Hạn phúc khảo"
                readonly
                v-bind="attrs"
                :rules="[$rules.required]"
                class="required"
                v-on="on"
                outlined
              ></v-text-field>
            </template>
            <v-date-picker v-model="reviewDate" no-title scrollable @input="menu = false" />
          </v-menu>
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="reviewReturnDate"
                label="Hạn trả phúc khảo"
                readonly
                v-bind="attrs"
                :rules="[$rules.required]"
                class="required"
                v-on="on"
                outlined
              ></v-text-field>
            </template>
            <v-date-picker v-model="reviewReturnDate" no-title scrollable @input="menu = false" />
          </v-menu>
          <v-text-field label="Địa điểm" v-model="location" outlined required :rules="[$rules.required]"></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SelectAcademicLevel from '../../components/basic/input/SelectAcademicLevel.vue'
export default {
  props: {
    state: Boolean
  },
  components: {
    SelectAcademicLevel
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: '',
      grade: '',
      type: '',
      //   gradeReview: 'true',
      date: '',
      reviewDate: '',
      reviewReturnDate: '',
      location: '',
      phase: '',
      academicLevel: null,
      menu: false,
      menu2: false,
      menu3: false,
      typeOptions: [
        { label: 'Cuối kỳ', value: 'final' },
        { label: 'Giữa kỳ', value: 'midTerm' },
        { label: 'Thi khác', value: 'extra' }
      ],
      reviewOptions: [
        { label: 'Có', value: 'true' },
        { label: 'Không', value: 'false' }
      ]
    }
  },
  methods: {
    ...mapActions('exam', ['createExam']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    acaChange(event) {
      this.academicLevel = event
    },
    async submit() {
      if (this.$refs.form.validate()) {
        let data = {
          name: this.name,
          grade: this.grade,
          type: this.type,
          //   gradeReview: this.gradeReview,
          startDate: this.date,
          reviewDate: this.reviewDate,
          academicLevel: this.academicLevel,
          reviewReturnDate: this.reviewReturnDate,
          location: this.location,
          ongoing: 'true',
          status: 'active',
          phase: this.phase
        }
        const createExam = await this.createExam({ ...data })

        if (createExam) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        } else {
          this.$alert.error('Lỗi tạo sản phẩm')
        }
      }
    },
    resetForm() {
      this.name = ''
      this.acronym = ''
      this.grade = ''
      this.note = ''
      this.type = ''
      this.phase = ''
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
